import { debug } from 'lib/logging'

export const convertFrom24To12Format = (time24) => {
  const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1)
  const period = +sHours < 12 ? `AM` : `PM`
  const hours = +sHours % 12 || 12

  return `${hours}:${minutes} ${period}`
}

export const convertFrom12To24Format = (time12) => {
  debug(`kolla`, `convertFrom12To24Format`, time12)
  const [time, modifier] = time12.split(` `)
  let [hours, minutes] = time.split(`:`)

  if (hours === `12`) {
    hours = `00`
  }
  if (modifier === `PM`) {
    hours = parseInt(hours, 10) + 12
  }

  return `${String(hours).padStart(2, `0`)}:${minutes}`
}
